import { createStore } from 'vuex'

const store = createStore({
    state: {
        ProjectForm: JSON.parse(localStorage.getItem("ProjectForm")) || {},
        RouterForm: JSON.parse(localStorage.getItem("RouterForm")) || {},
        notification: null, // 存储通知信息
        aicontent: "", // 存储AI内容
        calllistform: {},
        makePhoneform: {},
        telephoneAccess: {},
        labelOptions: [
            { label: "咨询类", value: "1" },
            { label: "投诉类", value: "2" }
        ],
    },
    getters: {
        ProjectForm: state => state.ProjectForm,
        RouterForm: state => state.RouterForm,
        aicontent: state => state.aicontent
    },
    mutations: {
        setProjectForm(state, data) {
            state.ProjectForm = data
            localStorage.setItem("ProjectForm", JSON.stringify(data))
        },
        setRouterForm(state, data) {
            state.RouterForm = data
            localStorage.setItem("RouterForm", JSON.stringify(data))
        },
        setAicontent(state, data) {
            state.aicontent = data
        },
        //挂断事件通知
        triggerEvent(state, payload) {
            state.notification = {
                data: payload.data,
                timestamp: Date.now() // 确保每次触发都是新对象
            };
        },
        //工单补录
        changecalllistform(state, data) {
            state.calllistform = data;
        },
        //拨打电话
        makePhoneChange(state, data) {
            state.makePhoneform = data;
        },
        //接入电话
        telephoneAccessChang(state, data) {
            state.telephoneAccess = data;
        },
    },
})

export default store
